import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import YesNoRadioButtonPanel from '../../components/Buttons/RadioButtonPanel/YesNoRadioButtonPanel';
import ComboBox from '../../components/ComboBox';
import './DataCollector.scss';
import Input from '../Input';

class DataCollector extends BaseComponent {

  constructor(props) {
    super(props);

    // Initialize all expected state variable here
    this.state={ field1: this.props.field1, field2: this.props.field2, 
      field3: this.props.field3, field4: this.props.field4 };
  }

  componentDidMount() {
  }

  locateField(element) {

    const { fields } = this.props;
    let field = null;
    let dataIdStr = element.getAttribute('data-id');
    let parent = element.parentElement;
    if (!dataIdStr) {
      while (parent) {
        dataIdStr = parent.getAttribute('data-id');
        if (dataIdStr) {
          break;
        }
        parent = parent.parentElement;
      }
    }
    if (dataIdStr) {
      dataIdStr = dataIdStr.replace('field-', '').replace('edit-', '').replace('delete-', '');
    }
    let dataId = parseInt(dataIdStr, 10);
    if (isNaN(dataId)) {
      dataId = dataIdStr;
    }

    if (dataId || dataId == 0) {
      for (var i = 0; i < fields.length; i++) {
        if (dataId == 0 && !fields[i].id) {
          field = fields[i];
          break;
        }
        else if (fields[i].id == dataId) {
          field = fields[i];
          break;
        }
      }
    }
    return field;
  }

  handleFieldChange(e) {
    const { handleChanges } = this.props;
    const field = this.locateField(e.target);
    if (field) {
      switch (field.setting_type) {
      case 1:
        field.text_value = e.target.value;  
        break;
      case 2:
        field.float_value = parseFloat(e.target.value);  
        break;
      case 3:
        field.integer_value = parseInt(e.target.value, 10);  
        break;
      default:
        break;
      }
    }
    if (handleChanges) {
      handleChanges(field);
    }
  }

  handleRadioButtonChange(option) {
    const { handleChanges } = this.props;

    if (option.data) {
      let field = option.data;
      if (field) {
        field.boolean_value = option.type == 'yes' ? option.value : (option.type == 'no' ? !option.value : false);
        handleChanges(field, true);
      }
    }
  }

  handleEdit(e) {
    const { handleSettingEdit } = this.props;
    const field = this.locateField(e.target);
    if (field) {
      if (handleSettingEdit) {
        handleSettingEdit(field);
      }
    }
  }

  handleDelete(e) {
    const { handleSettingDelete } = this.props;
    const field = this.locateField(e.target);
    if (field) {
      if (handleSettingDelete) {
        handleSettingDelete(field);
      }
    }
  }

  handleSelection(type, option) {
    if (option.field) {
      option.field.text_value = option.name;
      if (this.props.handleChanges) {
        this.props.handleChanges(option.field, true);
      }
    }
  }

  handleIntSelection(type, option) {
    if (option.field) {
      const value = parseInt(type.replace('choose-', ''), 10);
      option.field.integer_value = value;
      if (this.props.handleChanges) {
        this.props.handleChanges(option.field, true);
      }
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      const field = this.locateField(e.target);
      if (field) {
        if (this.props.handleChanges) {
          this.props.handleChanges(field, true);
        }
      }
    }
  }

  handleSetFocus(element) {
    if (element && this.focusElement != element) {
      this.focusElement = element;
      element.focus();
    }
  }

  render() {
    let { fields, height, selectedField } = this.props;
    if (!fields) {
      return null;
    }
    const nonDeletedFields = fields.filter(field => {
      return !field.toBeDeleted;
    });
    let keyValue = 1;
    const fieldCollection = nonDeletedFields.map(field => {
      let fieldInput = null;
      let selected = false;
      if (selectedField && field.id == selectedField.id) {
        selected = true;
      }
      if (selected) {
        switch (field.setting_type) {
        case 1:
          fieldInput = <Input key={keyValue++} className="field input-input-field"
              defaultValue={field.text_value} placeholder="Input Text"
              onChange={this.handleFieldChange} ref={(element) => { this.handleSetFocus(element); }}
              onBlur={this.handleFieldChange} dataId={'field-' + (field.id ? field.id : '0')}
              onKeyDown={this.handleKeyDown} />;
          break;
        case 2:
          fieldInput = <Input key={keyValue++} className="field input-input-field" defaultValue={field.float_value} placeholder="Input Decimal Number" onChange={this.handleFieldChange}
              onBlur={this.handleFieldChange} dataId={'field-' + (field.id ? field.id : '0')} ref={(element) => { this.handleSetFocus(element); }}
              onKeyDown={this.handleKeyDown} />;
          break;
        case 3:
          if (field.min_value && field.max_value) {
            let options = [];
            let currentOption = null;
            for (var i = field.min_value; i <= field.max_value; i++) {
              const option = { type: 'choose-' + i, name: i + (field.units ? ' ' + field.units : ''), field: field };
              options.push(option);
              if (i == field.integer_value) {
                currentOption = option;
              }
            }
            fieldInput = <ComboBox id={keyValue} key={keyValue++} options={options} currentOption={currentOption} hasBorder={false} underlined={true} width={140}
                height={30} displayFontStyle={{ fontSize: '12px' }} handleSelection={this.handleIntSelection} />;
          }
          else {
            fieldInput = <Input key={keyValue++} className="field input-input-field" defaultValue={field.integer_value} placeholder="Input  Number" onChange={this.handleFieldChange}
                onBlur={this.handleFieldChange} dataId={'field-' + (field.id ? field.id : '0')} ref={(element) => { this.handleSetFocus(element); }}
                onKeyDown={this.handleKeyDown} />;
          }
          break;
        case 4:
          fieldInput = <YesNoRadioButtonPanel key={keyValue++} horizontal={true} panelLabelPosition="none" yes={field.boolean_value}
              handleSelection={this.handleRadioButtonChange} data={field} textOnly={true} />;
          break;
        case 5:
          if (field.selection_value) {
            const optionsParsed = JSON.parse(field.selection_value);
            let type = 1;
            let currentOption = null;
            const options = optionsParsed.map(option => {
              const addOption = { type: (type++) + '', name: option.name, field: field };
              if (field.text_value == option.name) {
                currentOption = addOption;
              }
              return addOption;
            });
            if (options.length > 0) {
              fieldInput = <ComboBox id={keyValue} key={keyValue++} options={options} currentOption={currentOption} hasBorder={false} underlined={true} width={140}
                  height={30} displayFontStyle={{ fontSize: '12px' }} handleSelection={this.handleSelection} />;
            }
          }
          break;
        default:
          break;
        }
      }
      else {
        switch (field.setting_type) {
        case 1:
          fieldInput = <div key={keyValue++} className="field input-input-field">{field.text_value}</div>;
          break;
        case 2:
          fieldInput = <div key={keyValue++} className="field input-input-field">{field.float_value}</div>;
          break;
        case 3:
          if (field.min_value && field.max_value) {
            let options = [];
            let currentOption = null;
            for (let i = field.min_value; i <= field.max_value; i++) {
              const option = { type: 'choose-' + i, name: i + (field.units ? ' ' + field.units : ''), field: field };
              options.push(option);
              if (i == field.integer_value) {
                currentOption = option;
              }
            }
            fieldInput = <div id={keyValue} className="field input-input-field">{currentOption ? currentOption.name : ''}</div>;
          }
          else {
            fieldInput = <div key={keyValue++} className="field input-input-field">{field.integer_value}</div>;
          }
          break;
        case 4:
          fieldInput = <YesNoRadioButtonPanel key={keyValue++} horizontal={true} panelLabelPosition="none" yes={field.boolean_value}
              handleSelection={this.handleRadioButtonChange} data={field} textOnly={true} />;
          break;
        case 5:
          if (field.selection_value) {
            const optionsParsed = JSON.parse(field.selection_value);
            let type = 1;
            let currentOption = null;
            const options = optionsParsed.map(option => {
              const addOption = { type: (type++) + '', name: option.name, field: field };
              if (field.text_value == option.name) {
                currentOption = addOption;
              }
              return addOption;
            });
            if (options.length > 0) {
              fieldInput = <div id={keyValue} key={keyValue++} className="field input-input-field">{currentOption ? currentOption.name : ''}</div>;
            }
          }
          break;
        default:
          break;
        }
      }
      return <div className={'data-collector-block ' + (selected ? 'selected' : '')} key={'wrapper-' + (field.id ? field.id : '0')}
        onClick={this.handleEdit}
        data-id={'field-' + (field.id ? field.id : '0')}>
        <div className="input-block">
        <span className="input-label">{field.setting_label + (field.units ? ' (in ' + field.units + ')' : '') +
          (field.field_required ? ' (Required to be input in the field)' : '')}</span>
          {fieldInput}
        </div>
        <div className="delete-button" onClick={this.handleDelete} data-id={'delete-' + (field.id ? field.id : '0')}>
        </div>
      </div>;
    });

    let scrollStyle = {};
    if (height) {
      scrollStyle.height = height;
    }
    
    return (
      // Replace with the appropriate HTML
      <div className="data-collector" style={scrollStyle}>
        <div className="data-collector-scroller" style={scrollStyle}>
          {fieldCollection}
        </div>
      </div>
    );
  }
}

export default (DataCollector);



// WEBPACK FOOTER //
// ./src/components/DataCollector/index.js